var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragDropIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-365 -62)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(364.5 62)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    rx: 41,
    transform: "translate(0.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-9.32,0c2.437,0,3.883-1.508,3.883-4.008S-6.883-8-9.266-8h-2.766V0Zm-1.262-1.254V-6.746h1.234c1.625,0,2.473.906,2.473,2.738s-.848,2.754-2.516,2.754ZM-4.125,0h1.414V-3.527a1.282,1.282,0,0,1,1.352-1.3A2.7,2.7,0,0,1-.7-4.746v-1.3a3.4,3.4,0,0,0-.508-.039A1.5,1.5,0,0,0-2.691-5h-.062V-6H-4.125Zm6.73.117A2.808,2.808,0,0,0,5.48-2.977a2.812,2.812,0,0,0-2.875-3.1A2.812,2.812,0,0,0-.27-2.977,2.808,2.808,0,0,0,2.605.117Zm.008-1.133c-.973,0-1.449-.867-1.449-1.965s.477-1.977,1.449-1.977c.957,0,1.434.879,1.434,1.977S3.57-1.016,2.613-1.016ZM6.676,2.25H8.09v-3.2h.059A1.809,1.809,0,0,0,9.867.105c1.414,0,2.473-1.121,2.473-3.1,0-2-1.09-3.086-2.477-3.086a1.78,1.78,0,0,0-1.715,1.07H8.066V-6H6.676ZM8.062-3c0-1.164.5-1.918,1.41-1.918.941,0,1.426.8,1.426,1.918s-.492,1.945-1.426,1.945C8.57-1.055,8.062-1.836,8.062-3Z",
    transform: "translate(406 134.008)",
    fill: "#533ffb"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(380.336 74.327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.173,6A20.187,20.187,0,0,0,6,26.173a20.169,20.169,0,1,0,34.433-14.26A19.933,19.933,0,0,0,26.173,6Zm12.8,32.972h0a18.137,18.137,0,1,1,5.287-12.8A18.054,18.054,0,0,1,38.972,38.972Z",
    transform: "translate(0 0)",
    fill: "#533ffb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.747,51.492,53.3,54.936V42.043a1.043,1.043,0,1,0-2.087,0V54.936l-3.443-3.443a1.033,1.033,0,1,0-1.461,1.461L51.53,58.17a1.008,1.008,0,0,0,1.461,0l5.217-5.217a1.033,1.033,0,1,0-1.461-1.461Z",
    transform: "translate(-26.088 -24.311)",
    fill: "#533ffb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragDropIcon);
export default __webpack_public_path__ + "static/media/drag-drop-icon.7ee7363d23c402427fefd58cb2ed1efe.svg";
export { ForwardRef as ReactComponent };